import { useTownsContext } from '../components/TownsContextProvider';
import { useCallback } from 'react';
import { useCredentialStore } from '../store/use-credential-store';
import { useCasablancaStore } from '../store/use-casablanca-store';
import { AuthStatus } from './login';
export const useLogout = () => {
    const { environmentId } = useTownsContext();
    const { setAuthStatus } = useCasablancaStore();
    const { setCasablancaCredentials } = useCredentialStore();
    const { client } = useTownsContext();
    return useCallback(async function () {
        setAuthStatus(AuthStatus.DisconnectingFromRiver);
        if (client) {
            try {
                await client.logout();
                console.log('Logged out');
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
            }
            catch (ex) {
                console.error('Error logging out:', ex?.stack);
                throw new Error('Error logging out');
            }
        }
        setAuthStatus(AuthStatus.None);
        if (environmentId) {
            setCasablancaCredentials(environmentId, null);
        }
    }, [setAuthStatus, client, environmentId, setCasablancaCredentials]);
};
//# sourceMappingURL=use-logout.js.map